import React from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import { LinePlot } from '@mui/x-charts/LineChart';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { ChartsTooltip } from '@mui/x-charts/ChartsTooltip';
import Box from '@mui/material/Box';

// import StormDateDropDown from "../LID/StormDateDropDown";

const findDataRange = (dataArray) => {
    if (!dataArray || dataArray.length === 0) return { start: 0, end: 0 };

    let startIdx = 0;
    let endIdx = dataArray.length - 1;

    // Find first non-zero/non-null value
    while (startIdx < dataArray.length &&
    (dataArray[startIdx] === 0 || dataArray[startIdx] === null || isNaN(dataArray[startIdx]))) {
        startIdx++;
    }

    // Find last non-zero/non-null value
    while (endIdx >= 0 &&
    (dataArray[endIdx] === 0 || dataArray[endIdx] === null || isNaN(dataArray[endIdx]))) {
        endIdx--;
    }

    return { start: startIdx, end: endIdx };
};

// This component produces the graph for outfalls, where we only want to plot outflow
function OutfallChartBase({ x, y, selectedLayer }) {
    if (!Array.isArray(x) || !Array.isArray(y) || x.length === 0 || y.length === 0) {
        return null; // No data to render
    }

    const firstTimestamp = new Date(x[0]);
    const xAxisData = x.map(timestamp => ((new Date(timestamp) - firstTimestamp) / 3600000)); // Convert timestamps to hours

    // Get ranges for each data series
    //const y1Range = findDataRange(y1); // Filter this only based on runoff
    const yRange = findDataRange(y);

    // Add 2 hours to pad the time range
    if (!yRange || yRange.start > yRange.end) return;
    const filteredIndices = [...Array(yRange.end + 5 - yRange.start).keys()].map(i => i + yRange.start);


    // Create filtered arrays for our dataset
    const filteredXAxisData = filteredIndices.map(i => xAxisData[i]);
    const filteredY1 = filteredIndices.map(i => y[i]);


    const dataset = filteredXAxisData.map((time, index) => ({
        time,
        runoff: filteredY1[index],
    }));

    const series = [
        { type: 'line', dataKey: 'runoff', color: '#26a6e0' },
    ];

    return (
        <Box sx={{ width: '100%', height: '500px', alignItems: 'flex-start', overflow: 'hidden', padding: '0px 0px 0px 0px' }}>
        <Box sx={{ marginBottom: '0px', marginLeft: '0px', marginTop: '5px' }}> </Box>
        <Box sx={{ marginBottom: '0px', marginLeft: '0px', marginTop: '0px' }}>
            {/* <StormDateDropDown /> */}
            <ResponsiveChartContainer
            sx={{
                //change axis label and line colors
                "& .MuiChartsAxis-tickContainer .MuiChartsAxis-tickLabel":{
                    fontFamily: "Roboto",
                    },
                "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel":{
                    fill:"#26a6e0"
                },
                "& .MuiChartsAxis-left .MuiChartsAxis-line":{
                    stroke:"#26a6e0",
                    },
                "& .MuiChartsAxis-left .MuiChartsAxis-tick":{
                    stroke:"#26a6e0",
                    },
                "& .MuiChartsAxis-left .MuiChartsAxis-label":{
                    fill:"#26a6e0",
                    },
            }}
            series={series}
            xAxis={[
                {
                scaleType: 'band',
                dataKey: 'time',
                label: 'Time (hours)',
                tickInterval: (value, index) => index % 24 === 0,
                }
            ]}
            yAxis={[
                { id: 'leftAxis', label: selectedLayer === 'subcatchment' ? "Runoff (cfs)" : "Overflow (cfs)" },
            ]}
            dataset={dataset}
            height={245}
            >
            <LinePlot />
            <ChartsXAxis />
            <ChartsYAxis axisId="leftAxis" />
            <ChartsTooltip/>
            </ResponsiveChartContainer>
        </Box>
        </Box>
    );      
}

export default OutfallChartBase;